// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"963ddaf5","513":"eba2f2b6","703":"88afdf25"}[chunkId] + ".chunk.js";
};